export enum AnswerType {
  Multi = 1,
  Open = 2,
  Single = 3,
  SinglePunchImage = 4,
  MultiPunchImage = 5,
}
